import type React from 'react';
import { useTranslation } from 'react-i18next';
import { MigrationAction } from './MigrationAction';
import { MigrationStateLayout } from './MigrationStateLayout';

interface TermsAcceptedStateProps {
  isAdmin: boolean;
  /** i18n key naming why the API would refuse; when set, no action is offered. */
  blockedReasonKey: string | null;
  isStarting: boolean;
  onStart: () => void;
  currencyNotice?: string;
}

/** Terms accepted, nothing sent to Shopify yet. */
export const TermsAcceptedState: React.FC<TermsAcceptedStateProps> = ({
  isAdmin,
  blockedReasonKey,
  isStarting,
  onStart,
  currencyNotice,
}) => {
  const { t } = useTranslation();

  return (
    <MigrationStateLayout
      tone="neutral"
      status={t('settings.subscription.successFeeMigration.termsAccepted.body')}
      currencyNotice={currencyNotice}
    >
      <MigrationAction
        isAdmin={isAdmin}
        blockedReasonKey={blockedReasonKey}
        isStarting={isStarting}
        onAct={onStart}
        actionKey="settings.subscription.successFeeMigration.termsAccepted.action"
        viewerHelperKey="settings.subscription.successFeeMigration.termsAccepted.viewerHelper"
      />
    </MigrationStateLayout>
  );
};
